/**
 * Place search via the Open-Meteo geocoding API — the same free, keyless
 * vendor as our weather data, called straight from the browser. Resolves
 * city/town names (and many postal codes) to coordinates + IANA timezone.
 * Weather-grid resolution (~1–10 km) means city-level precision is exactly
 * as accurate as the forecast itself.
 */

export interface GeoPlace {
  name: string;
  latitude: number;
  longitude: number;
  timezone?: string;
  /** State/province and country, for disambiguating the result list. */
  region?: string;
  country?: string;
}

interface GeocodingResult {
  name: string;
  latitude: number;
  longitude: number;
  timezone?: string;
  admin1?: string;
  country?: string;
}

export async function searchPlaces(query: string): Promise<GeoPlace[]> {
  const url =
    'https://geocoding-api.open-meteo.com/v1/search' +
    `?name=${encodeURIComponent(query.trim())}&count=6&language=en&format=json`;
  const res = await fetch(url);
  if (!res.ok) throw new Error('Place search is unavailable right now — try again shortly.');
  const data = (await res.json()) as { results?: GeocodingResult[] };
  return (data.results ?? []).map((r) => ({
    name: r.name,
    latitude: r.latitude,
    longitude: r.longitude,
    timezone: r.timezone,
    region: r.admin1,
    country: r.country,
  }));
}
